/* TRU speed: no jQuery needed. Opens the accordions in .pac-10 / .pac-11 sections. */
document.querySelectorAll('.pac-10 .accordion-details, .pac-11 .accordion-details').forEach(function (d) { d.setAttribute('open', ''); });
